(function () {
  const script = document.createElement('script');
  script.type = 'text/javascript';
  script.src = 'https://code.jquery.com/jquery-3.6.0.min.js';

  document.querySelector('head').appendChild(script);

  script.onload = function () {
    const gpdmc = {
      init(form) {
        console.log(form)
        const chart = $(form[0]).closest('.wp-block-group').find('.gpdmc-chart-v1');
        if (!chart.length) {
          console.error('gpdmc: .gpdmc-chart-v1 not found relative to form', form[0]);
          return;
        }
        const chartReset = form.find('input[type="reset"]');
        const inputMinLimit = 1400;
        const disclaimer = $('.gpdmc-disclaimer').detach();
        const modal = chart[0].parentNode.parentNode;

        if ($(modal).find('.close-button').length === 0) {
          const closeButton = document.createElement('button');
          closeButton.className = 'trigger-modal close-button';
          closeButton.innerHTML = '&times;';
          closeButton.addEventListener('click', () => {
            $(modal).removeClass('active');
            form.closest('.wp-block-group > div').css('z-index', '2');
            form.closest('.wp-block-group').css('z-index', '2');
            $('.entry-content').css('z-index', '3');
          });
          modal.appendChild(closeButton);
        }

        chartReset.on('click', () => chart.empty());

        form.submit((e) => {
          e.preventDefault();

          const loanBalance = form.find('input[name="loanBalance"]').val();
          const loan = { balance: gpdmc.cleanValues(loanBalance) };

          chart.empty();

          if (loan.balance < inputMinLimit) {
            alert('Please enter a digit greater than 1400.');
            return;
          }

          $(modal).addClass('active');
          form.closest('.wp-block-group > div').css('z-index', '990');
          form.closest('.wp-block-group').css('z-index', '990');
          $('.entry-content').css('z-index', '200');

          const output = gpdmc.calculateValues(loan.balance);
          gpdmc.outputChart(output, chart, disclaimer);
        });
      },

      cleanValues: (value) => value.replace(/[^0-9.]/g, ''),

      numberWithCommas: (number) => number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ','),

      calculateValues(input) {
        const initial = parseFloat(input);

        let gDebtBalance = initial;
        let gTotalInterest = 0;
        let gLiquidationTerm = 0;

        let oDebtBalance = initial;
        let oTotalInterest = 0;
        let oLiquidationTerm = 0;

        // GreenPath
        while (gDebtBalance !== 0) {
          const payment = initial * 0.021;
          if (payment > gDebtBalance) {
            gDebtBalance = 0;
          } else {
            const interest = (gDebtBalance * 0.08) / 12;
            gTotalInterest += interest;
            gDebtBalance -= payment - interest;
          }
          gLiquidationTerm++;
        }

        // Customer
        while (oDebtBalance > 0) {
          const payment = Math.max(oDebtBalance * 0.05, 25);
          const interest = (oDebtBalance * 0.24) / 12;
          oTotalInterest += interest;
          oDebtBalance -= payment - interest;
          oLiquidationTerm++;
        }

        const gTotal = gTotalInterest + initial;
        const oTotal = oTotalInterest + initial;
        const savings = oTotalInterest.toFixed(2) - gTotalInterest.toFixed(2);

        return {
          summary: {
            amount: `$${gpdmc.numberWithCommas(savings.toFixed(0))}`,
            duration: `${oLiquidationTerm - gLiquidationTerm} meses`
          },
          total: {
            customer: Math.ceil(oTotal * 100) / 100,
            greenpath: Math.ceil(gTotal * 100) / 100
          },
          duration: {
            customer: oLiquidationTerm,
            greenpath: gLiquidationTerm
          },
          apr: { customer: '24%', greenpath: '8%' }
        };
      },

      drawBarChart(containerId, title, categories, values, colors, labelFormatter) {
        const container = document.getElementById(containerId);
        if (!container) return;

        const canvas = document.createElement('canvas');
        canvas.width = container.offsetWidth || 400;
        canvas.height = 420;
        canvas.style.borderRadius = '4px';
        container.appendChild(canvas);

        const ctx = canvas.getContext('2d');
        const W = canvas.width;
        const H = canvas.height;
        const margin = { top: 70, right: 30, bottom: 65, left: 80 };
        const chartW = W - margin.left - margin.right;
        const chartH = H - margin.top - margin.bottom;

        const dataMax = Math.max(...values);
        const rawStep = dataMax / 4;
        const magnitude = 10 ** Math.floor(Math.log10(rawStep));
        const normalized = rawStep / magnitude;
        const niceNorm = normalized < 1.5 ? 1 : normalized < 3 ? 2 : normalized < 7 ? 5 : 10;
        const step = niceNorm * magnitude;
        let maxValue = Math.ceil(dataMax / step) * step;
        if (maxValue <= dataMax) maxValue += step;
        const ySteps = Math.round(maxValue / step);

        const animDuration = 2000;
        let startTime = null;

        const drawRoundedTopRect = (x, y, w, h, r) => {
          const radius = Math.min(r, h, w / 2);
          ctx.beginPath();
          ctx.moveTo(x + radius, y);
          ctx.lineTo(x + w - radius, y);
          ctx.quadraticCurveTo(x + w, y, x + w, y + radius);
          ctx.lineTo(x + w, y + h);
          ctx.lineTo(x, y + h);
          ctx.lineTo(x, y + radius);
          ctx.quadraticCurveTo(x, y, x + radius, y);
          ctx.closePath();
          ctx.fill();
        };

        const easeOut = (t) => 1 - (1 - t) ** 3;

        const draw = (progress) => {
          ctx.clearRect(0, 0, W, H);

          ctx.fillStyle = '#e9f7fa';
          ctx.fillRect(0, 0, W, H);

          ctx.fillStyle = '#666666';
          ctx.font = 'bold 13px Roboto, sans-serif';
          ctx.textAlign = 'center';
          ctx.textBaseline = 'top';
          ctx.fillText(title.toUpperCase(), W / 2, 15);

          for (let i = 0; i <= ySteps; i++) {
            const yVal = step * i;
            const yPos = margin.top + chartH - (chartH * i / ySteps);

            ctx.strokeStyle = '#cccccc';
            ctx.lineWidth = 0.5;
            ctx.beginPath();
            ctx.moveTo(margin.left, yPos);
            ctx.lineTo(margin.left + chartW, yPos);
            ctx.stroke();

            ctx.fillStyle = '#666666';
            ctx.font = 'bold 11px Roboto, sans-serif';
            ctx.textAlign = 'right';
            ctx.textBaseline = 'middle';
            ctx.fillText(labelFormatter(yVal), margin.left - 6, yPos);
          }

          const barGroupWidth = chartW / categories.length;
          const barWidth = barGroupWidth * 0.5;

          categories.forEach((category, i) => {
            const animBarH = (values[i] / maxValue) * chartH * progress;
            const x = margin.left + barGroupWidth * i + (barGroupWidth - barWidth) / 2;
            const y = margin.top + chartH - animBarH;

            const gradient = ctx.createLinearGradient(0, margin.top + chartH, 0, y);
            gradient.addColorStop(0, colors[i][0]);
            gradient.addColorStop(1, colors[i][1]);

            ctx.fillStyle = gradient;
            drawRoundedTopRect(x, y, barWidth, animBarH, 4);

            ctx.fillStyle = '#333333';
            ctx.font = 'bold 11px Roboto, sans-serif';
            ctx.textAlign = 'center';
            ctx.textBaseline = 'top';
            ctx.fillText(category.toUpperCase(), x + barWidth / 2, margin.top + chartH + 10);

            if (progress > 0.15) {
              ctx.fillStyle = '#333333';
              ctx.font = 'bold 18px Roboto, sans-serif';
              ctx.textAlign = 'center';
              ctx.textBaseline = 'bottom';
              ctx.fillText(labelFormatter(values[i]), x + barWidth / 2, y - 5);
            }
          });
        };

        const animate = (timestamp) => {
          if (!startTime) startTime = timestamp;
          const progress = Math.min((timestamp - startTime) / animDuration, 1);
          draw(easeOut(progress));
          if (progress < 1) requestAnimationFrame(animate);
        };

        requestAnimationFrame(animate);
      },

      outputChart(output, chartContainer, chartDisclaimer) {
        chartContainer.prepend(
          `<p class="summary">Con un plan de manejo de deudas, puede ahorrar <strong>${output.summary.amount}</strong> Con un plan de manejo de deudas, puede ahorrar <strong>${output.summary.duration}</strong> ¡antes!</p>`
        );

        chartContainer.append('<div id="chart-payments"></div>');
        gpdmc.drawBarChart(
          'chart-payments',
          'Pagos totales de intereses y capital',
          ['Por su cuenta', 'Consumer DMP'],
          [output.total.customer, output.total.greenpath],
          [['#ff7f00', '#ff7f00'], ['#7aa65f', '#7aa65f']],
          (v) => `$${gpdmc.numberWithCommas(Math.round(v))}`
        );

        chartContainer.append('<div id="chart-duration"></div>');
        gpdmc.drawBarChart(
          'chart-duration',
          'Meses para pagar saldos',
          ['Por su cuenta', 'Consumer DMP'],
          [output.duration.customer, output.duration.greenpath],
          [['#ff7f00', '#ff7f00'], ['#7aa65f', '#7aa65f']],
          (v) => String(Math.round(v))
        );

        chartContainer.append(chartDisclaimer);
      }
    };

    $('form[name="gpdmc"]').each((_, form) => gpdmc.init($(form)));
  };
})();

const closeModal = function (event) {
  const modal = document.querySelector('.calc-popup.active');

  if (modal) {
    if (!modal.contains(event.target)) {
      modal.classList.remove('active');
      document.querySelector('html').classList.remove('no-scroll');
    }
  }
}

document.addEventListener('click', closeModal);
